import styled from 'styled-components'

export const ChartDot = styled.div`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #a1ff68;
`

export const CarouselImageBox = styled.div`
  height: 20vh;
  width: 10vw;
  border: 1px solid black;
`

export const CardBox = styled.div`
  width: 100%;
  margin-left: 44%;
  margin-top: 5%;
  height: 30vh;
  display: flex;
  flex-direction: row;
  position: relative;
`

export const Card = styled.div`
  width: 100%;
  height: 100%;
  /* border: 1px solid black; */
  background-color: rgba(255, 255, 255, 1);
  border-radius: 19px;
`

export const ArrowButton = styled.button`
  position: absolute;
  z-index: 5;
  padding: 10px;
  font-family: 'Nunito';
  background: none !important;
  outline: none !important;
  border: none;
  font-size: 2rem;
  color: #a1ff68;

  &.right {
    right: 42%;
    top: 45%;

    @media only screen and (max-width: 600px) {
      right: 39%;
    }
  }

  &.left {
    left: 0%;
    top: 45%;
  }
`

export const CompareImagesBox = styled.div`
  width: 100%;
  overflow: scroll;
  display: flex;
  flex-direction: column;
  vertical-align: baseline;
  padding: 0px 3.8%;
  box-sizing: border-box;
  cursor: grab;
  overflow: auto;
  /* width */
  ::-webkit-scrollbar {
    width: 2px;
    box-sizing: border-box;
    height: 6px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background-color: white;
    border-radius: 4px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  scrollbar-color: transparent;

  /* scrollbar-width: 8px; */
`
export const CompareImagesScroll = styled.div`
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  -webkit-box-pack: center;
  justify-content: center;
  flex-direction: row;
  overflow-y: auto;
  width: max-content;
  padding: 2% 0 4% 0;
  cursor: grab;
  overflow: auto;
`

export const CompareImage = styled.div`
  display: inline-flex;
  flex-direction: column;
  -webkit-box-align: end;
  align-items: end;
  align-self: center;
  -webkit-box-pack: center;
  justify-content: center;
  /* margin-right: 3.7vw; */
  cursor: pointer;
  width: 45%;
  height: 100%;
  border: 1px solid black;
  margin: 0 10px;
`

export const SideContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 30vw;
  /* height: 40vh; */

  box-sizing: border-box;
  padding: 1% 1% 3% 1%;
  margin: 10px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 19px;

  @media only screen and (max-width: 600px) {
    width: 66vw;
  }
`
export const MobileTopNavigation = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 10px;
  margin-top: 5%;
`
